<script setup lang="ts">
import {
    QIcon,
    QInput,
    type QDateProps,
    type QInputProps,
} from 'quasar';
import { ref, computed } from 'vue';

const props = defineProps<{
    modelValue: string|null,
    inputProps: Omit<QInputProps, 'modelValue'>,
    dateProps?: Omit<QDateProps, 'modelValue'>,
    isIconPrepended: boolean,
    hideDatePopup?: boolean,
}>();

defineEmits(['update:model-value']);

const date = computed(() => props.modelValue);
const dateInput = ref<QInput|null>(null);
const iconRef = ref<QIcon|null>(null);
const isReadonly = computed(() => props.inputProps.readonly ?? false);
const validate = async () => dateInput.value?.validate();

defineExpose({
    validate,
});

</script>
<template>
    <q-input
        ref="dateInput"
        v-model="date"
        mask="##/##/####"
        v-bind="inputProps"
        role="textbox"
        @update:model-value="$emit('update:model-value', $event)"
    >
        <template
            v-if="isIconPrepended"
            #prepend
        >
            <q-icon
                v-show="!isReadonly"
                ref="iconRef"
                name="event"
                :title="!hideDatePopup ? 'Open date picker' : 'date picker icon'"
                :class="{ 'cursor-pointer': !hideDatePopup }"
                color="black"
                :role="!hideDatePopup ? 'button' : 'icon'"
                :tabindex="!hideDatePopup ? 0 : -1"
                :aria-hidden="hideDatePopup"
            />
        </template>
        <template
            v-else
            #append
        >
            <q-icon
                v-if="!isReadonly"
                ref="iconRef"
                name="event"
                :title="!hideDatePopup ? 'Open date picker' : 'date picker icon'"
                :class="{ 'cursor-pointer': !hideDatePopup }"
                color="black"
                :role="!hideDatePopup ? 'button' : 'icon'"
                :tabindex="!hideDatePopup ? 0 : -1"
                :aria-hidden="hideDatePopup"
            />
        </template>
        <q-popup-proxy
            v-if="!hideDatePopup && iconRef"
            :target="iconRef?.$el"
            cover
            transition-show="scale"
            transition-hide="scale"
        >
            <q-date
                v-model="date"
                v-bind="dateProps"
                mask="MM/DD/YYYY"
                @update:model-value="$emit('update:model-value', $event)"
            >
                <div class="row items-center justify-end">
                    <q-btn
                        v-close-popup="true"
                        label="Close"
                        color="primary"
                        flat
                    />
                </div>
            </q-date>
        </q-popup-proxy>
    </q-input>
</template>
<style scoped lang="css">
</style>
